/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-console */

import {
  useEffect, useState,
} from 'react';
import axios from 'axios';
import TokenManager from '@zeeve-platform/login-utility';
import moment from 'moment';
import chart from '../../../images/chart.png';
import infocircle from '../../../images/info-circle.png';
import cloud1 from '../../../images/cloud-select-1.png';
import cloud2 from '../../../images/cloud-select-0.png';
import cloud3 from '../../../images/cloud-select-2.png';
import cloud4 from '../../../images/cloud-select-4.png';
import cloud5 from '../../../images/cloud-select-5.svg';
import zeeveCloud from '../../../images/cloud-zeeve.svg';
import runningicon from '../../../images/notifications-green.png';
import googlecloud from '../../../images/cloud-select-3.png';
import pendingIcon from '../../../images/notifications-time.png';
import { RpcDetailType } from './types';
// import { getBlockHeight as getBlockHeightData } from '../../../services/network';
import { getNodeCloudData, getRpcDetailData } from './api';

const getCloudImage = (zeeveManaged: boolean, str: string | number) => {
  if (zeeveManaged) return zeeveCloud;

  switch (str.toString().toLowerCase()) {
    case '2051b7e0-0210-47e9-870f-76162f49ebf9':
      return cloud2;
    case '6cd1b682-bfe7-414c-9e4c-8ab8f8b20ac6':
      return cloud1;
    case '8691db48-8595-4eb9-9c2a-7bab535d9475':
      return cloud3;
    case 'fa02e4b7-118d-4163-8b15-26f5d18a6820':
      return cloud4;
    case 'c4ba9fa8-8fc3-4005-a837-6fa34df26ab7':
      return googlecloud;
    case '2ca3821c-864e-4a11-8280-6326db48f28c':
      return cloud5;

    default:
      return cloud2;
  }
};

interface Props {
    cloudId: string;
    endpoint: string;
    region: string;
    createdAt: string;
    networkType: string;
    node: string | number;
    state: string;
    networkId: string | number;
    setFlag: (x: boolean) => void;
    redirection_url: string;
    setNodeId: (x: string) => void;
    nodeID: string;
    nodeName: string;
}
interface RegionBody {
    id: string | number;
    region: string;
    region_name: string;
    managed: boolean;
}
const LandingStakingCard = ({
  cloudId,
  region,
  node,
  state,
  endpoint,
  networkId,
  setFlag,
  redirection_url,
  setNodeId,
  nodeID,
  nodeName,
  createdAt,
  networkType,
}: Props) => {
  const [regions, setRegion] = useState({} as RegionBody);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [analyticsUrls, setAnalyticsUrls] = useState<{ dashboardName: string; dashboardURL: string }[]>([]);

  const loadRegions = async () => {
    const response: any = await getNodeCloudData(node);
    console.log(response);
    if (response && response.data) {
      setRegion(response.data);
    } else {
      setRegion({} as RegionBody);
      console.error('error getting regions');
    }
  };
  const getRegionName = () => {
    if (regions.region && regions.region_name) return `${regions.region} (${regions.region_name})`;
    if (regions.region && !regions.region_name) return regions.region;
    if (regions.region_name && !regions.region) return regions.region_name;
    return '';
  };

  const getNodeAnalyticsUrls = async () => {
    try {
      const token = TokenManager.getInstance().getAccessToken();
      const analyticsDashboardURLsResponse = await axios.get(`/analytics/api/dashboard-urls?nodeID=${node}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (analyticsDashboardURLsResponse && analyticsDashboardURLsResponse.data) {
        setAnalyticsUrls(analyticsDashboardURLsResponse.data);
      }
    } catch (error) {
      setAnalyticsUrls([]);
    }
  };

  useEffect(() => {
    loadRegions();
    if (state && (state.toLowerCase() === 'provisioning' || state.toLowerCase() === 'ready')) {
      getNodeAnalyticsUrls();
    }
  }, []);

  const showAnalyticsMessage = () => {
    const div2 = document.getElementById('analyticsDiv');
    if (div2) div2.style.display = 'block';
    setTimeout(() => {
      if (div2) div2.style.display = 'none';
    }, 1000);
  };
  return (
        <tr>
            <td scope="row" className="p-1 mt-1 align-middle text-center">
                <p className="fs-6 mt-1 mb-0" title="Node Name">
                    {nodeName || 'Unknown'}
                </p>
            </td>
            <td scope="row" className="p-1 mt-1 align-middle text-center">
                <p className="fs-6 mt-1 mb-0" title="Cloud Region">
                    <img
                        src={getCloudImage(regions.managed, cloudId)}
                        height="25px"
                        width="25px"
                        alt=""
                        className="m-1"
                    />
                    <span>{getRegionName() || 'Unknown'}</span>
                </p>
            </td>
            <td scope="row" className="p-1 mt-1 align-middle text-center">
                <p className="fs-6 mt-1 mb-0" title="Network type">
                    {networkType || 'Unknown'}
                </p>
            </td>
            <td scope="row" className="p-1 mt-1 align-middle text-center">
                <p className="fs-6 mt-1 mb-0 text-center" title="Created At">
                    {moment(createdAt).format('DD/MM/YYYY hh:mm a')}
                </p>
            </td>
            <td scope="row" className="p-1 mt-1 align-middle text-center">
                <div className="d-flex justify-content-around align-items-center">
                    {(
                        <div className="p-1 col">
                            <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                            >
                                <li className="btnNodeli px-1">
                                    <div className="btn-group btnNodeli">
                                        <img
                                            className="btnNode dropdown-toggle"
                                            src={chart}
                                            height="22px"
                                            alt=""
                                            id={`${node}dropdownMenuButton2`}
                                            data-toggle="dropdown"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        />
                                        <div
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton2"
                                            style={{ zIndex: 999999 }}
                                        >
                                            {analyticsUrls && analyticsUrls.length > 0 ? (
                                              analyticsUrls.map((item) => (
                                                    <a
                                                        className="dropdown-item"
                                                        href={item.dashboardURL}
                                                        key={item.dashboardName}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {item.dashboardName}
                                                    </a>
                                              ))
                                            ) : (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                          showAnalyticsMessage();
                                                        }}
                                                    >
                                                        Analytics Not Ready
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                          showAnalyticsMessage();
                                                        }}
                                                    >
                                                        Analytics Not Ready
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                          showAnalyticsMessage();
                                                        }}
                                                    >
                                                        Analytics Not Ready
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </li>
                                {/* {state !== 'requested' && (
                                    <li
                                        className='btnNodeli'
                                        aria-hidden
                                        onClick={() => {
                                            clickedDeleteIcon(node);
                                        }}
                                    >
                                        <img className='btnNode mx-1' src={deleteicon} height='22px' alt='' />
                                    </li>
                                )} */}
                                {state === 'ready' && (
                                    <img src={runningicon} style={{ height: '22px' }} title="Running" alt="" />
                                )}
                                {state === 'provisioning' && (
                                    <img src={pendingIcon} style={{ height: '22px' }} title="Pending" alt="" />
                                )}
                                {state !== 'ready' && state !== 'provisioning' && (
                                    <img src={infocircle} style={{ height: '22px' }} title="Stop" alt="" />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
            {showLoader && 'Loading'}
        </tr>
  );
};

export default LandingStakingCard;
